module.exports = __webpack_public_path__ + "static/media/client.876ff4d3.svg";